import { PostHogProvider as Provider } from 'posthog-js/react';
import type { ReactNode } from 'react';

import { ViteEnv } from '@/env';

export const PostHogProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  if (import.meta.env.DEV) {
    return <>{children}</>;
  }

  return (
    <Provider
      options={{
        api_host: 'https://us.i.posthog.com',
        session_recording: {
          maskAllInputs: false,
          maskInputOptions: {
            password: true,
          },
        },
      }}
      apiKey={ViteEnv.VITE_POSTHOG_API_KEY}
    >
      {children}
    </Provider>
  );
};
